export function getQueryParam(variable, defaultValue) {
  const query = location.search.substring(1);
  const vars = query.split('&');

  for (let index = 0; index < vars.length; index++) { // eslint-disable-line
    const pair = vars[index].split('=');

    if (pair[0] === variable) {
      return decodeURIComponent(pair[1]);
    }
  }

  return defaultValue || false;
}

export function getLocationParam(key, defaultValue, location) {
  if (!key) {
    return defaultValue;
  }
  if (!location) {
    return defaultValue;
  }
  const { query } = location;
  if (!query) {
    return defaultValue;
  }
  return query[key] || defaultValue;
}

export function getLocationParamBoolean(key, defaultValue, location) {
  const param = getLocationParam(key, defaultValue, location);
  const type = typeof param;
  if (type === 'boolean') {
    return param;
  } else if (type === 'string') {
    const paramLc = param.toLowerCase();
    if (paramLc === '0' || paramLc === 'false') {
      return false;
    } else if (paramLc === '1' || paramLc === 'true') {
      return true;
    }
  }
  return defaultValue;
}



// WEBPACK FOOTER //
// ./js/utils/get-query-param.js